import { IApplicationStateModel } from './application.model';

export const applicationStateDefaults: IApplicationStateModel = {
    applications: undefined,
    selectedApplicationId: '1', // By default only the eventor is loaded default application
};
